import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const getSingleCampaign = async (campaignId) => {
  try {
    const campaignDocument = doc(db, "campaign", campaignId);
    const campaignSnapshot = await getDoc(campaignDocument);
    let campaignData = {
      ...campaignSnapshot.data(),
    };
    return campaignData;
  } catch (error) {
    console.log(error);
  }
};

export default getSingleCampaign;
